import Representative from "./Representative";

// src/translations.js
const translations = {
  en: {
    // navbar
    navItemHome: "Home",
    navItemAbout: "About Cairomed",
    navItemOurRep: "Our Representative",
    navItemContact: "Contact Us",
    navItemProducts: "Products",
    navItemBlogs: "Blogs",

    // hero-section
    heroSectionTitle: "CAIROMED",
    heroSectionSubTitle: "High Quality Products",
    heroSectionParagraph:"Welcome to Cairomed, a leading provider of specialized poultry Products in Egypt...",

    // About-section
    aboutSectionTitle:"About Cairomed",
    aboutSectionParagraph:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic itaque iure excepturi commodi nisi iste.",

    // About Us Page
    aboutUsTitle: "About Cairomed",
    aboutUsContent: "Cairomed is a trusted and leading provider of specialized poultry health products in Egypt, dedicated to advancing the country's poultry industry through high-quality, innovative solutions. We offer a wide range of veterinary medicines, vaccines, nutritional supplements, and biosecurity products, all tailored to meet the evolving needs of poultry farmers and veterinary professionals across the nation. With years of experience and a deep understanding of the local market, Cairomed has built a solid reputation for excellence, reliability, and customer satisfaction.Our commitment to quality starts with carefully selected international partners and manufacturers who share our values of safety, efficacy, and compliance with international standards. We are proud to work alongside a growing network of veterinarians, agricultural experts, and poultry producers, providing them not only with premium products but also with expert guidance and technical support.At Cairomed, we believe that healthy poultry means a healthier and more productive food chain. That's why we constantly invest in scientific research, education, and training programs that empower our customers and ensure sustainable development in the poultry sector. Our vision is to be the go-to partner for poultry health solutions in Egypt and beyond, contributing to food security and agricultural progress for future generations.",
    missionTitle: "Our Mission",
    missionContent: "Our mission is to be a trusted partner for poultry farmers by providing innovative medicines and solutions that improve poultry health and farm productivity. We are committed to excellence in product quality, technical support, and customer service, ensuring that our clients receive the best possible outcomes for their operations.",
    visionTitle: "Our Vision",
    visionContent: "To be the leading provider of poultry products in Egypt, recognized for our commitment to quality, innovation, and customer satisfaction. We aim to contribute to the health and well-being of the poultry industry through sustainable practices and continuous improvement of our products and services.",

    //main product section

    cardOneHeading:"Bacitromed",
    cardOneContent:"  Bacitracin methylene di salicylate 53 gm equivalent to Bacitracin base 44 gm",
    cardTwoHeading:"Streptomycin",
    cardTwoContent:"  Streptomycin sulphate 100.0 gm Equivalent to Streptomycin base 79.8 gm",
    cardThreeHeading:"Floromed",
    cardThreeContent:"  Each 100ml contains Florfenicol 10g",
    cardFourHeading:"Osmulin",
    cardFourContent:"  Tiamulin Hydrogen Fumarate 125mg.",


    // servicesection-section 
    servicesSectionTitle:"Our Services",
    servicesSection1stSlideTitle:"Trusted Commercial Agent",
    servicesSection1stSlideParagraph:"Strong business relationships with leading companies and clients.",
    servicesSection2ndSlideTitle:"World-Class Factory",
    servicesSection2ndSlideParagraph:"Recognized globally for exceptional quality across the Middle East, Africa, and beyond.",
    servicesSection3rdSlideTitle:"Flexible Sales Policies",
    servicesSection3rdSlideParagraph:"Ensuring service delivery at the right time and place.",
    servicesSection4thSlideTitle:"Unique Pharmaceutical Products",
    servicesSection4thSlideParagraph:"Comprehensive solutions for diverse medical conditions.",


    // main-product-section 
    mainProductsSectionTitle:"Our Main Products",

    description: "Description",
    welcome: "Welcome to our store!",
    addToCart: "Add to Cart",
    checkout: "Proceed to Checkout",


    // Header 
    repHeaderTitle:"Our Representatives",
    repHeaderParagraph:"Our representatives are dedicated to providing the highest quality products and services to our customers.",
    repHeaderParagraph2:"They are available to answer any questions and help with your needs.",

    // Products
    productsHeaderTitle:"Our Products",
    productsHeaderParagraph:"Our products are exceptional and designed to meet the needs of poultry farmers and veterinarians across the country.",

    // Representative
    cardNameLabel:"Name",
    cardPhoneLabel:"Phone",
    cardEmailLabel:"Email",
    cardRegionLabel:"Region",

    readMoreBTN:"Read More",
    moreDetailsBTN:"More Details",

    poultryHealthTitle: "Poultry Health Tips",
    biosecurityTitle: "Biosecurity Measures",
    biosecurityContent: "Implement strict biosecurity protocols to prevent disease transmission. Maintain clean facilities, control visitor access, and ensure proper disinfection procedures.",
    nutritionTitle: "Optimal Nutrition",
    nutritionContent: "Provide balanced feed with essential nutrients. Monitor feed quality and ensure proper storage conditions. Regular water quality checks are crucial for flock health.",
    vaccinationTitle: "Vaccination Programs",
    vaccinationContent: "Follow recommended vaccination schedules. Store vaccines properly and administer them correctly. Regular health monitoring helps prevent disease outbreaks.",
  
  // footer
   footertopic1: "About Cairomed",
   footertopic2: "Stay in Touch",
   footersubtopic1: "Vision, Mission & Goals",
   footersubtopic2: "Our Products",
   footersubtopic3: "Our Representatives",
   footerfacebook: "Facebook",   
   footerlinkedin: "LinkedIn",
   footerwhatsapp: "WhatsApp",
   footercopyright: "© 2025 Developed by ",
   footerdev1: "Eng Mohamed Wanas (Frontend developer)",
   footerdev2: "Eng Mohamed Abusaif (Backend developer)",
   footerdev3: "Eng Eman Abdullah (ui/ux designer)",
   formPrivacyPolicy: "Privacy Policy",
   formTermsAndConditions: "Terms and Conditions",

   ourkeyachivements: "Our Key Achievements",
   ourkeyachivements1:"Representatives",
    ourkeyachivements2:"Years of experince",
    ourkeyachivements3:"Clients",
    ourkeyachivements4:"Products",
  },
  ar: {
    // navbar
    navItemHome: "الرئيسية",
    navItemAbout: "عن كايروميد",
    navItemOurRep: "ممثلينا",
    navItemContact: "تواصل معنا",
    navItemProducts: "منتجاتنا",
    navItemBlogs: "مقالات",

    // hero section

    heroSectionTitle: "كايروميد",
    heroSectionSubTitle: "منتجات عالية الجودة",
    heroSectionParagraph:"مرحبًا بك في كايروميد، الشركة الرائدة في تقديم المنتجات المتخصصة للدواجن في مصر...",


    // About-section
    aboutSectionTitle:"عن كايروميد",
    aboutSectionParagraph:"لوريم إيبسوم ألم سيت أميت كونسيكتيتور أديبيسينج إليت. وهنا، فمن الصواب أن يستثنوا هذا الشخص.",

    // About Us Page
    aboutUsTitle: "عن كايروميد",
    aboutUsContent: "كايروميد هي مزود موثوق ورائد للمنتجات الصحية المتخصصة للدواجن في مصر، تسعى جاهدة لتعزيز صناعة الدواجن في البلاد من خلال حلول مبتكرة وعالية الجودة. نقدم مجموعة واسعة من الأدوية البيطرية، اللقاحات، المكملات الغذائية، ومنتجات الأمان الحيوي، وجميعها مصممة لتلبية احتياجات المربين والأطباء البيطريين المتجددة في جميع أنحاء الجمهورية. وبفضل خبرتنا الطويلة وفهمنا العميق للسوق المحلي، نجحت كايروميد في بناء سمعة قوية قائمة على التميز والموثوقية ورضا العملاء. نلتزم في كايروميد بالجودة منذ الخطوة الأولى، من خلال اختيار شركاء ومصنعين دوليين يشاركوننا قيم السلامة والفعالية والامتثال للمعايير العالمية. نحن فخورون بشراكتنا مع شبكة متنامية من الأطباء البيطريين والخبراء الزراعيين ومنتجي الدواجن، حيث نزودهم ليس فقط بمنتجات متميزة، بل أيضاً بالدعم الفني والمشورة المتخصصة. نؤمن في كايروميد أن صحة الدواجن تعني سلسلة غذاء أكثر صحة وإنتاجية. لذلك، نستثمر باستمرار في البحث العلمي وبرامج التدريب والتثقيف، لتمكين عملائنا ودعم التنمية المستدامة في قطاع الدواجن. رؤيتنا هي أن نكون الشريك الأول لحلول صحة الدواجن في مصر وخارجها، مساهمين في تحقيق الأمن الغذائي والتقدم الزراعي للأجيال القادمة.",
    missionTitle: "مهمتنا",
    missionContent: "مهمتنا هي أن نكون شريكًا موثوقًا لمزارعي الدواجن من خلال توفير الأدوية والحلول المبتكرة التي تحسن صحة الدواجن وإنتاجية المزرعة. نحن ملتزمون بالتميز في جودة المنتج والدعم الفني وخدمة العملاء، مما يضمن حصول عملائنا على أفضل النتائج الممكنة لعملياتهم.",
    visionTitle: "رؤيتنا",
    visionContent: "أن نكون المزود الرائد لمنتجات الدواجن في مصر، معروفين بالتزامنا بالجودة والابتكار ورضا العملاء. نهدف إلى المساهمة في صحة ورفاهية صناعة الدواجن من خلال الممارسات المستدامة والتحسين المستمر لمنتجاتنا وخدماتنا.",


    //main product section

    cardOneHeading:"باسيتروميد",
    cardOneContent:"باسيتراسين ميثيلين داى سالسيلات 53 جم ( يكافىء باسيتراسين قاعدى 44 جم )",
    cardTwoHeading:"ستربتوميسين",
    cardTwoContent:"  ستربتوميسين سلفات: 100 جم (تعادل 79.8 جم من قاعدة الستربتوميسين)",
    cardThreeHeading:"فلوروميد",
    cardThreeContent:"  كل 100 ملليلتر تحتوى على فلورفينيكول 10 جم",
    cardFourHeading:"أوسميولين",
    cardFourContent:"   تياميولين هيدروجين فــيوماريــت 125 ملليجرام",

    // services-section 
    
      servicesSectionTitle: "خدماتنا",
      servicesSection1stSlideTitle: "وكيل تجاري موثوق",
      servicesSection1stSlideParagraph: "علاقات تجارية قوية مع الشركات والعملاء الرائدين.",
      servicesSection2ndSlideTitle: "مصنع عالمي المستوى",
      servicesSection2ndSlideParagraph: "معترف به عالميًا لجودته الاستثنائية في الشرق الأوسط وأفريقيا وخارجها.",
      servicesSection3rdSlideTitle: "سياسات بيع مرنة",
      servicesSection3rdSlideParagraph: "ضمان تقديم الخدمات في الوقت والمكان المناسبين.",
      servicesSection4thSlideTitle: "منتجات دوائية فريدة",
      servicesSection4thSlideParagraph: "حلول شاملة لمختلف الحالات الطبية.",
  
        // main-product-section 
    mainProductsSectionTitle:"منتجاتنا الرئيسية",
    

    description: "الوصف",
    welcome: "مرحبًا بكم في متجرنا!",
    addToCart: "أضف إلى السلة",
    checkout: "إتمام الشراء",

    // Header 
    repHeaderTitle:"ممثلينا",
    repHeaderParagraph:"ممثلينا ملتزمون بتقديم المنتجات والخدمات بأعلى لجودة لعملائنا .",
    repHeaderParagraph2:"يمكنهم الإجابة على أي أسئلة ومساعدتك في حال الحاجة.",

    productsHeaderTitle:"منتجاتنا",
    productsHeaderParagraph:"منتجاتنا متميزة ومصممة لتلبية احتياجات المربين والأطباء البيطريين المتجددة في جميع أنحاء الجمهورية.",

    // Representative
    cardNameLabel:"الاسم",
    cardPhoneLabel:"الهاتف",
    cardEmailLabel:"البريد الإلكتروني",
    cardRegionLabel:"المنطقة",

    readMoreBTN:"اقرأ المزيد",
    moreDetailsBTN:"المزيد",

    poultryHealthTitle: "نصائح صحة الدواجن",
    biosecurityTitle: "إجراءات الأمان الحيوي",
    biosecurityContent: "تنفيذ بروتوكولات صارمة للأمان الحيوي لمنع انتقال الأمراض. الحفاظ على مرافق نظيفة، التحكم في وصول الزوار، وضمان إجراءات التطهير المناسبة.",
    nutritionTitle: "التغذية المثلى",
    nutritionContent: "توفير علف متوازن يحتوي على العناصر الغذائية الأساسية. مراقبة جودة العلف وضمان ظروف التخزين المناسبة. فحوصات جودة المياه المنتظمة ضرورية لصحة القطيع.",
    vaccinationTitle: "برامج التطعيم",
    vaccinationContent: "اتباع جداول التطعيم الموصى بها. تخزين اللقاحات بشكل صحيح وإعطائها بشكل صحيح. المراقبة الصحية المنتظمة تساعد في منع تفشي الأمراض.",
 
    ourkeyachivements: "إنجازاتنا الرئيسية",
    ourkeyachivements1:"ممثلينا",
    ourkeyachivements2:"سنوات من الخبرة",
    ourkeyachivements3:"العملاء",
    ourkeyachivements4:"المنتجات",


    // footer
    footertopic1: "عن كايروميد",
    footertopic2: "ابق على تواصل",
    footersubtopic1: "الرؤية، المهمة والأهداف",
    footersubtopic2: "منتجاتنا",
    footersubtopic3: "ممثلينا",
    footerfacebook: "فيسبوك",
    footerlinkedin: "لينكد إن",
    footerwhatsapp: "واتساب",
    footercopyright: "© 2025 تم تطويره بواسطة ",
    footerdev1: "المهندس محمد وناس (مطور الواجهة الأمامية)",
    footerdev2: "المهندس محمد أبو سيف (مطور الواجهة الخلفية)",
    footerdev3: "المهندسة إيمان عبد الله (مصممة واجهة المستخدم وتجربة المستخدم)",
    formPrivacyPolicy: "سياسة الخصوصية",
    formTermsAndConditions: "الشروط والأحكام",
    
  },
};

export default translations;
